export default __webpack_public_path__ + "static/media/icons8-mongodb-480.a8889d62.png";